import React from "react"
import { Box, Grid } from "@mui/material"
import CommonTypo from "../../../components/CommonTypo"
import insightsProgressStyles from "../insightsClasses"
import Entries from "../common/entries"
import AvgRating from "../common/avgRating"
import HighestEntryOn from "../common/highestEntryOn"
import { baseEndpoints } from "../../../services/config"
import { FontAwesomeIconRender, ICON_SLECTIN_TABS } from "../../../components/IconSelectionPopOver"
const closest = (needle, haystack = []) => {
    if (haystack && haystack.length) {
        return haystack.reduce(function (prev, curr) {
            return Math.abs(curr - needle) < Math.abs(prev - needle) ? curr : prev;
        });
    }
    return null;
};
const nearestValue = (val, influenceItem) => {
    let arr = [];
    if (
        influenceItem.type === "TYPE2" &&
        influenceItem.options.length &&
        influenceItem.options[Math.round(val) - 1]
    ) {
        return influenceItem.options[Math.round(val) - 1].colorCode;
    }
    if (influenceItem?.type === "TYPE12") {
        let arr = [];
        if (influenceItem?.options && influenceItem?.options.length) {
            arr = [...influenceItem?.options].map((it) => it.value);
        }
        if (
            influenceItem.type === "TYPE2" &&
            influenceItem.options.length &&
            influenceItem.options[val - 1]
        ) {
            return influenceItem.options[val - 1].colorCode;
        }

        const returnVal = closest(val, arr);
        console.log("nearestValue ?? returnVal", returnVal);

        if (
            influenceItem?.options &&
            influenceItem?.options.length &&
            !Number.isNaN(returnVal)
        ) {
            const foundIndexOfValue = influenceItem?.options.findIndex(
                (it) => it.value === returnVal
            );

            if (foundIndexOfValue > -1) {
                return influenceItem?.options[foundIndexOfValue]?.colorCode;
            }
        }
        return false;
    }
    if (influenceItem?.options && influenceItem?.options.length) {
        arr = [...influenceItem?.options].map((it) => it.value);
    }
    const returnVal = closest(val, arr);
    if (influenceItem?.options && influenceItem?.options.length && returnVal) {
        const foundIndexOfValue = influenceItem?.options.findIndex(
            (it) => it.value === returnVal
        );
        if (foundIndexOfValue > -1) {
            return influenceItem?.options[foundIndexOfValue]?.colorCode;
        }
    }
    return false;
};
const GoalsInfluences = ({ influenceResponse, selectOutcome, isDarkMode = false }) => {
    const classesV2 = insightsProgressStyles()
    console.log("influenceResponse", influenceResponse, selectOutcome);
    const weekCurrent = influenceResponse?.weekCount?.currentWeekcount * 100 / 7
    const weekPrevious = influenceResponse?.weekCount?.lastWeekCount * 100 / 7
    const { mostInflueceOutcome = [], specificInflunceData = [] } = influenceResponse
    let color = "var(--color-new-main)"
    const newColor = nearestValue(influenceResponse?.avg || 0, selectOutcome)
    if (newColor) {
        color = newColor
    }
    return (
        <>
            <Box sx={{
                display: "flex",
                gap: "12px",
                flexWrap: "wrap"
            }}>
                {/* <Box sx={{
                    padding: "24px",
                    border: "1px solid #EEEEEE",
                    display: "flex",
                    borderRadius: "12px",
                    flexDirection: "column",
                    gap: "8px",
                    justifyContent: "space-between",
                    width: "276px",
                    height: "184px"
                }}>
                    <CommonTypo size={24} lineHeight={24} color="#3E4240" fontWeight={700} extraSx={{
                        whiteSpace: "nowrap",
                    }}>{"Weekly goal"}</CommonTypo>
                    <CommonTypo size={24} lineHeight={24} color="#3E4240" fontWeight={700} extraSx={{
                        whiteSpace: "nowrap",
                    }}>{"71%"}</CommonTypo>
                    <Box sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                    }}>
                        <Box sx={{
                            display: "flex",
                            justifyContent: "space-between"
                        }}>
                            <CommonTypo size={16} lineHeight={16} color="#656565" fontWeight={600} extraSx={{
                                whiteSpace: "nowrap",
                            }}>{"3.6 avg"}</CommonTypo>
                            <CommonTypo size={16} lineHeight={16} color="#656565" fontWeight={400} extraSx={{
                                whiteSpace: "nowrap",
                            }}>{"4.1 avg"}</CommonTypo>
                        </Box>
                        <Progress achive={70} />
                    </Box>
                </Box> */}
                <Entries currentWeekcount={influenceResponse?.weekCount?.currentWeekcount || 0}
                    lastWeekCount={influenceResponse?.weekCount?.lastWeekCount}
                    weekCurrent={weekCurrent}
                    weekPrevious={weekPrevious} isDarkMode={isDarkMode} />
                {selectOutcome.type !== "TYPE3" && <AvgRating rating={influenceResponse?.avg || 0} color={color} isDarkMode={isDarkMode} />}
                {specificInflunceData.length > 0 && (
                    <HighestEntryOn specificInflunceData={specificInflunceData} isDarkMode={isDarkMode} getColor={(avg) => {
                        if (selectOutcome.type === "TYPE3") {
                            if (Number(avg) > 0 && Number(avg) <= 20) {
                                return "#F57575"
                            }
                            if (Number(avg) > 20 && Number(avg) <= 40) {
                                return "#FFB378"
                            }
                            if (Number(avg) > 40 && Number(avg) <= 60) {
                                return "#F7D257"
                            }
                            if (Number(avg) > 60 && Number(avg) <= 80) {
                                return "#CDE675"
                            }
                            if (Number(avg) > 80 && Number(avg) <= 100) {
                                return "#ADE888"
                            }
                        }
                        return nearestValue(avg || 0, selectOutcome)
                    }} />
                )}

                <Box sx={{
                    padding: "24px",
                    border: "1px solid #EEEEEE",
                    display: "flex",
                    borderRadius: "12px",
                    flexDirection: "column",
                    gap: "8px",
                    height: "184px",
                    width: "276px",
                    justifyContent: "space-between"
                }}>
                    <CommonTypo size={24} lineHeight={24} color={isDarkMode ? "var(--color-text-primary)" : "#3E4240"} fontWeight={700} extraSx={{
                        whiteSpace: "nowrap",
                    }}>{"Most influence on"}</CommonTypo>
                    <Box sx={{
                        height: "68px",
                        padding: "16px",
                        borderRadius: "8px",
                        width: "228px",
                        border: "1px solid #F6F6F6",
                        background: "#F6F6F6"
                    }}>
                        <div className={classesV2.outcomeSelectionBoxContent}>
                            {/* {(
                                <div className="outcome-influ-card" style={{ background: "var(--color-new-main)", width: "36px", height: "36px", borderRadius: "5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <svg width="24" height="24" viewBox="0 0 24 24">
                                        <path d={mostInflueceOutcome[0]?.outcome[0]?.icon} fill="#fff" />
                                    </svg>
                                </div>
                            )} */}
                            {(mostInflueceOutcome[0]?.outcome[0]?.icon && mostInflueceOutcome[0]?.outcome[0]?.icon.length > 50) ? (
                                <div className="outcome-influ-card" style={{ background: "var(--color-new-main)", width: "36px", height: "36px", borderRadius: "5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <svg width="24" height="24" viewBox="0 0 24 24">
                                        <path d={mostInflueceOutcome[0]?.outcome[0]?.icon} fill="#fff" />
                                    </svg>
                                </div>
                            ) : mostInflueceOutcome[0]?.outcome[0]?.icon && mostInflueceOutcome[0]?.outcome[0]?.iconType ? (
                                mostInflueceOutcome[0]?.outcome[0]?.iconType === ICON_SLECTIN_TABS.EMOJI ? <span style={{
                                    height: "24px",
                                    width: "24px",
                                    fontSize: "24px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                }}>{mostInflueceOutcome[0]?.outcome[0]?.icon}</span> :
                                    mostInflueceOutcome[0]?.outcome[0]?.iconType === ICON_SLECTIN_TABS.ICON ? <FontAwesomeIconRender selectedIcon={mostInflueceOutcome[0]?.outcome[0]?.icon} style={{
                                        height: "24px",
                                        width: "24px",
                                    }} /> :
                                        mostInflueceOutcome[0]?.outcome[0]?.iconType === ICON_SLECTIN_TABS.IMAGE ? <img
                                            alt="toggl"
                                            width="24px" height="24px"
                                            src={
                                                mostInflueceOutcome[0]?.outcome[0]?.icon
                                                    ? `${baseEndpoints.getImage}${mostInflueceOutcome[0]?.outcome[0]?.icon}`
                                                    : "/toggl.png"
                                            }
                                            style={{
                                                height: "24px",
                                                width: "24px",
                                                borderRadius: "10px"
                                            }}
                                        /> : <Box sx={{
                                            height: "24px",
                                            width: "24px",
                                            minHeight: "24px",
                                            minWidth: "24px",
                                        }}></Box>
                            ) : <Box sx={{
                                height: "24px",
                                width: "24px",
                                minHeight: "24px",
                                minWidth: "24px",
                            }}></Box>}
                            <Box sx={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                                width: "calc(100% - 100px)",
                                height: "32px",
                            }}>
                                <CommonTypo size={16} color={"#3E4240"} title={mostInflueceOutcome[0]?.outcome[0]?.name} lineHeight={16} fontWeight={600} extraSx={{
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                }}>{mostInflueceOutcome[0]?.outcome[0]?.name}</CommonTypo>
                                <CommonTypo size={12} color={"#656565"} lineHeight={12} fontWeight={400}>{"Current Avg."}</CommonTypo>
                            </Box>
                            <Box sx={{
                                display: "grid",
                                justifySelf: "flex-end",
                                right: 0
                            }}>
                                <CommonTypo size={26} color="#3E4240" fontWeight={500}>{mostInflueceOutcome[0]?.outcome[0]?.avg}</CommonTypo>
                            </Box>
                        </div>
                    </Box>
                </Box>
            </Box>

        </>
    )
}

export default GoalsInfluences


export const Progress = ({ total = 100, achive = 0, height = 16 }) => {
    return <Box sx={{
        background: "#EEEEEE",
        width: total + "%",
        height: height + "px",
        borderRadius: "8px"
    }}>
        <Box sx={{
            background: "var(--color-new-main)",
            width: `calc(${achive}%)`,
            height: height + "px",
            borderRadius: "8px"
        }} />
    </Box>
}

export const DayRender = ({ day, rating, success }) => {
    const percentage = (rating * 100) / 7
    return <Box sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end",
        height: "100%",
        alignItems: "center",
        gap: "8px"
    }}>
        <Box sx={{
            background: success ? "var(--color-new-main)" : "#EEEEEE",
            borderRadius: "8px",
            width: "59.86px",
            height: `calc(${percentage}%)`,
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            alignItems: "center",
            paddingBottom: "4px"
        }}>
            <CommonTypo size={16} color="#656565" fontWeight={success ? 600 : 400}>{rating}</CommonTypo>
        </Box>
        <CommonTypo size={16} color="#000000" fontWeight={success ? 600 : 400}>{day}</CommonTypo>
    </Box>
}